export default "__VITE_ASSET__C4He9kPm__"